var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "url(#paint0_radial_4715_1765)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#DA7D4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11C23 11.8284 22.3284 12.5 21.5 12.5C20.6716 12.5 20 11.8284 20 11C20 10.1716 20.6716 9.5 21.5 9.5C22.3284 9.5 23 10.1716 23 11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.5C18.7614 21.5 21 19.2614 21 16.5C21 13.7386 18.7614 11.5 16 11.5C13.2386 11.5 11 13.7386 11 16.5C11 19.2614 13.2386 21.5 16 21.5ZM16 19.5C17.6569 19.5 19 18.1569 19 16.5C19 14.8431 17.6569 13.5 16 13.5C14.3431 13.5 13 14.8431 13 16.5C13 18.1569 14.3431 19.5 16 19.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16.1C6 12.7397 6 11.0595 6.65396 9.77606C7.2292 8.64708 8.14708 7.7292 9.27606 7.15396C10.5595 6.5 12.2397 6.5 15.6 6.5H16.4C19.7603 6.5 21.4405 6.5 22.7239 7.15396C23.8529 7.7292 24.7708 8.64708 25.346 9.77606C26 11.0595 26 12.7397 26 16.1V16.9C26 20.2603 26 21.9405 25.346 23.2239C24.7708 24.3529 23.8529 25.2708 22.7239 25.846C21.4405 26.5 19.7603 26.5 16.4 26.5H15.6C12.2397 26.5 10.5595 26.5 9.27606 25.846C8.14708 25.2708 7.2292 24.3529 6.65396 23.2239C6 21.9405 6 20.2603 6 16.9V16.1ZM15.6 8.5H16.4C18.1132 8.5 19.2777 8.50156 20.1779 8.5751C21.0548 8.64674 21.5032 8.77659 21.816 8.93597C22.5686 9.31947 23.1805 9.93139 23.564 10.684C23.7234 10.9968 23.8533 11.4452 23.9249 12.3221C23.9984 13.2223 24 14.3868 24 16.1V16.9C24 18.6132 23.9984 19.7777 23.9249 20.6779C23.8533 21.5548 23.7234 22.0032 23.564 22.316C23.1805 23.0686 22.5686 23.6805 21.816 24.064C21.5032 24.2234 21.0548 24.3533 20.1779 24.4249C19.2777 24.4984 18.1132 24.5 16.4 24.5H15.6C13.8868 24.5 12.7223 24.4984 11.8221 24.4249C10.9452 24.3533 10.4968 24.2234 10.184 24.064C9.43139 23.6805 8.81947 23.0686 8.43597 22.316C8.27659 22.0032 8.14674 21.5548 8.0751 20.6779C8.00156 19.7777 8 18.6132 8 16.9V16.1C8 14.3868 8.00156 13.2223 8.0751 12.3221C8.14674 11.4452 8.27659 10.9968 8.43597 10.684C8.81947 9.93139 9.43139 9.31947 10.184 8.93597C10.4968 8.77659 10.9452 8.64674 11.8221 8.5751C12.7223 8.50156 13.8868 8.5 15.6 8.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4715_1765",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 23.5) rotate(-55.3758) scale(25.5196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIg);
export default __webpack_public_path__ + "static/media/icon_ig.1ee2839f396d033ddae1d5059745fa91.svg";
export { ForwardRef as ReactComponent };